import TilesList from './TilesList';

export default TilesList;
